import { Badge, Box } from '@usealloy/component-library';
import styled from 'styled-components';

export const StyledFooter = styled(Box)`
  &&& {
    height: 100%;
    padding: var(--cl-space-2) var(--cl-space-6);
    align-items: center;
  }
`;

export const StyledSpacer = styled.div`
  flex-grow: 1;
`;

export const StyledBadge = styled(Badge)`
  &&& {
    > div:first-child {
      width: auto;
      max-width: none;
    }
  }
`;

